import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { DashboardAdvancedDashletService } from '../dashboard-advanced-dashlet.service';


import { forkJoin, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { getTimeZone } from '../../../../../core/helpers/get-timezone';
import { TranslationPipe } from '../../../../features/translate/translation.pipe';
import { DownloadService } from '../../../../services/download.service';
import { TExportDashlet } from '../../dashboard-export-modal/dashboard-export-dashlet.model';
import { TDashletEventsRequestData } from '../../dashlet/dashlet-events/dashlet-events.consts';
import { TDashboardImageElementData } from '../dashboard-export-elements/dashboard-image-element';
import { generateExportDashletSimple } from '../dashboard-export-elements/dashboard-simple-dashlet';
import { createDashletWrapperElement } from './create-dashlet-wrapper-element';
import { findSimpleDashletData } from './find-dashlet-data';

@Injectable({
  providedIn: 'root',
})
export class DashboardExportService {
  dashletsWrapperElement: HTMLElement;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dashboardAdvancedDashletService: DashboardAdvancedDashletService,
    private translationPipe: TranslationPipe,
    private downloadService: DownloadService,
  ) {}

  export(
    dashletList: TExportDashlet[],
    dashletsData: TDashletEventsRequestData[],
    selectedLayout: string,
  ): Observable<Response> {
    return this.generateExportDashlets(dashletList, dashletsData).pipe(
      switchMap((dashlets) => {
        const body = {
          format: selectedLayout,
          timeGMT: getTimeZone(),
          dashlets,
        };

        const promptErrorText = this.translationPipe.transform('prompt_export_error_dashboard');

        return this.downloadService.fromRequest(
          'api/v1/dashboard/exports/pdf',
          body,
          promptErrorText,
        );
      }),
    );
  }

  generateExportDashlets(
    dashletList: TExportDashlet[],
    dashletsData: TDashletEventsRequestData[],
  ): Observable<TDashboardImageElementData[]> {
    this.dashletsWrapperElement = createDashletWrapperElement();

    const asyncHandlers: Observable<TDashboardImageElementData>[] = [];

    // comment to show images in the app
    this.document.body.appendChild(this.dashletsWrapperElement);

    dashletList.forEach((dashlet) => {
      if (dashlet.selected) {
        const dashletData = findSimpleDashletData(dashlet, dashletsData);

        if (dashletData) {
          asyncHandlers.push(generateExportDashletSimple(dashletData, dashlet));
        } else {
          asyncHandlers.push(
            this.dashboardAdvancedDashletService.generateAdvancedDashlet(
              this.dashletsWrapperElement,
              dashlet,
            ),
          );
        }
      }
    });

    return forkJoin(asyncHandlers).pipe(
      tap(() => {
        this.document.body.removeChild(this.dashletsWrapperElement);
      }),
    );
  }
}
